export const API_CONFIG = {
  BASE_URL: 'https://api.mylighthouse.co',
  ENDPOINTS: {
    ARTICLES: '/articles',
    ARTICLE_BY_SLUG: (slug: string) => `/articles/${slug}`,
  },
};